let sessionUuid: string | null = null;

export const setGASessionUuid = (uuid: string) => {
  sessionUuid = uuid;
};

export const trackGAEvent = ({ eventName, params = {} }) => {
  if (typeof window.gtag !== 'function') {
    console.warn('gtag not available');
    return;
  }

  window.ElevarDataLayer = window.ElevarDataLayer ?? [];

  window.ElevarDataLayer.push({
    event: eventName,
    externalId: sessionUuid,
    ...params,
  });
};

export const trackStartPersonalizedInsole = () => {
  trackGAEvent({ eventName: "per_ins_start" });
};

export const trackAppHandoffStart = () => {
  trackGAEvent({ eventName: "per_ins_app_handoff_start" });
};

export const trackAppHandoffFindRetailerLink = () => {
  trackGAEvent({ eventName: "per_ins_app_handoff_find_retailer_link" });
};

export const trackMobileSessionInitiated = () => {
  trackGAEvent({ eventName: "per_ins_mobile_session_initiated" });
};

export const trackMobileSessionFail = () => {
  trackGAEvent({ eventName: "per_ins_mobile_session_fail" });
};

export const trackAppHandoffComplete = () => {
  trackGAEvent({ eventName: "per_ins_app_handoff_complete" });
};

export const trackScanInProgressStart = () => {
  trackGAEvent({ eventName: "per_ins_scan_in_progress_start" });
};

export const trackScanComplete = () => {
  trackGAEvent({ eventName: "per_ins_scan_complete" });
};

export const trackPreviewStart = () => {
  trackGAEvent({ eventName: "per_ins_preview_start" });
};

type FormFieldType = 'query_param' | 'default' | 'user_selected';

export const trackPreviewFormField = (fieldName: string, fieldValue: string, type?: FormFieldType) => {
  trackGAEvent({
    eventName: "per_ins_preview_form_field",
    params: {
      fieldName: fieldName,
      fieldValue: fieldValue,
      ...(type && { fieldType: type }),
    },
  });
};

export const trackCompareMaterialsEngagement = () => {
  trackGAEvent({ eventName: "per_ins_compare_materials_engangement" });
};

export const trackPreviewEnd = () => {
  trackGAEvent({ eventName: "per_ins_preview_end" });
};

export const trackPersonalizationStart = () => {
  trackGAEvent({ eventName: "per_ins_personalization_start" });
};

export const trackPersonalizationFormField = (fieldName: string, fieldValue: string) => {
  trackGAEvent({
    eventName: "per_ins_personalization_form_field",
    params: {
      fieldName: fieldName,
      fieldValue: fieldValue,
    },
  });
};

interface AddToCartParams {
  currency: string;
  value: number;
  items: Array<{
    item_id: string;
    item_name: string;
    item_brand?: string;
    item_category?: string;
    item_variant?: string;
    price: number;
    quantity: number;
  }>;
}

export const trackAddToCart = (params: AddToCartParams) => {
  trackGAEvent({
    eventName: "add_to_cart",
    params: {
      currency: params.currency,
      value: params.value,
      items: params.items,
      source: "personalized_insole",
    }
  });

  trackGAEvent({ eventName: "per_ins_add_to_cart" });
};

export const trackPersonalizedInsoleEnd = () => {
  trackGAEvent({ eventName: "per_ins_end" });
};

export const trackExitPersonalizedInsole = () => {
  trackGAEvent({ eventName: "per_ins_exit" });
};
